import { useState } from "react";
import { MapPin } from "lucide-react";
import AvailabilityWidget from "@/components/shared/AvailabilityWidget";
import RotatingBadge from "../components/RotatingBadge";
import ChinarLeaf from "../components/ChinarLeaf";
import {
  useHomePageContent,
  HOME_DEFAULTS,
} from "@/features/admin-content/hooks/usePageContent";

const LOGO_SRC = "/logo.jpeg";

export default function Hero() {
  const { data } = useHomePageContent();
  const bgImage =
    data?.hero.backgroundImage ?? HOME_DEFAULTS.hero.backgroundImage;
  const [logoError, setLogoError] = useState(false);

  return (
    <section className="relative">
      <div className="grid lg:grid-cols-[0.95fr_1.05fr]">
        {/* Left — cream card */}
        <div className="relative flex flex-col justify-center overflow-hidden bg-metro-cream px-6 py-16 md:px-12 md:py-20 lg:px-16 lg:py-28">
          <ChinarLeaf className="pointer-events-none absolute -bottom-16 -left-16 h-[280px] w-[280px] text-metro-green-800 opacity-[0.07] md:h-[380px] md:w-[380px]" />
          <div className="relative max-w-xl">
            {/* Logo above eyebrow */}
            <div className="mb-5">
              {!logoError ? (
                <img
                  src={LOGO_SRC}
                  alt="Hotel Metropolis"
                  className="h-20 w-auto object-contain mix-blend-multiply"
                  onError={() => setLogoError(true)}
                />
              ) : null}
            </div>

            <p className="eyebrow mb-4 md:mb-5">Welcome to Metropolis</p>
            <h1 className="mb-4 font-serif text-4xl leading-[1.05] text-metro-green-950 md:text-5xl lg:text-6xl">
              Where the Valley
              <br />
              Feels Like Home
            </h1>
            <p className="mb-4 flex items-center gap-1.5 font-serif text-sm italic text-metro-green-800 md:mb-5">
              <MapPin size={14} />
              On the banks of Dal Lake · Srinagar, Kashmir
            </p>
            <p className="mb-6 text-base leading-relaxed text-metro-ink-muted md:mb-8">
              A boutique luxury hotel offering an intimate and refined stay in
              the heart of the valley. With 26 elegantly designed rooms, we
              blend modern comfort with the warmth of authentic Kashmiri
              hospitality.
            </p>
          </div>
        </div>

        {/* Right — image */}
        <div className="relative min-h-[320px] overflow-hidden md:min-h-[460px] lg:min-h-[640px]">
          {bgImage && (
            <img
              src={bgImage}
              alt="Dal Lake, Srinagar at golden hour"
              fetchPriority="high"
              className="absolute inset-0 h-full w-full object-cover"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/50" />
          <RotatingBadge />
        </div>
      </div>

      {/* Floating availability widget */}
      <div className="container-narrow relative z-10 px-4 md:px-6 lg:px-8">
        <div className="-mt-0 pt-4 md:-mt-10 lg:-mt-12 md:pt-0">
          <AvailabilityWidget />
        </div>
      </div>
    </section>
  );
}